import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

import component from "./IconV1.svelte";

defineComponent({
  tag: "oc-icon-v1",
  extendOptions: { useShadow: false },
  styles: () => import("./IconV1.global.scss?inline"),
  props: {
    color: { type: "String" },
    size: { type: "String", reflect: true },
    type: { type: "String", reflect: true },
    ocAriaLabel: { type: "String", attribute: "oc-aria-label" },
  },
  component: () => component,
});
